export type VendingMachineExternalServiceKey = {
  key: string
}

export type VendingMachineExternalServiceSettings = {
  serviceId: string
  active: boolean
}
export type ExternalServiceSettings = {
  enableExternalServices: boolean
  services: Array<VendingMachineExternalServiceSettings>
}

export type Params = {
  machineId: number
}

export type PostKeyParams = {
  machineId: number
}

export type PostExternalServiceParams = {
  machineId: number
  enableExternalServices: boolean
}
export type PostExternalServiceResult = {
  enableExternalServices: boolean
}

export type PutServiceIdParams = {
  machineId: number
  serviceId: string
  active: boolean
}

export const isParamsValid = (params: Partial<Params>): params is Params => {
  const { machineId } = params
  if (machineId) {
    return true
  }
  return false
}
